const appConfig = {
    //  apiPrefix: 'http://localhost:5102/api/',
    //  apFilePrefix: 'http://localhost:5102/',
    apiPrefix: 'https://api.complianceguru.co.in/api/',
    apFilePrefix: 'https://api.complianceguru.co.in/',
    authenticatedEntryPath: '/home',
    unAuthenticatedEntryPath: '/sign-in',
    tourPath: '/',
    enableMock: false
}

export default appConfig
